var render = function render(){var _vm=this,_c=_vm._self._c;return _c('papas-merge-questions-action-selection',{attrs:{"papa-merge-questions":_vm.papaMergeQuestions,"show-mark-as-loan-button":true,"first-title":"לחיוב הזה חסר פירוט."}})
}
var staticRenderFns = []

export { render, staticRenderFns }